module.exports = __webpack_public_path__ + "img/law1m.afb37575.jpg";